export default {
    baseStyle: {
        prices: {
            textAlign: 'right',
            direction: 'column',
            justifyContent: 'flex-end',
            alignItems: 'baseline',
            wrap: 'nowrap',
            marginLeft: 'auto',
            width: 'max-content',
            fontSize: '18px'
        },
        listText: {fontSize: '18px'}
    }
}
